import { Component, Input } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'skeletor-request-data',
  standalone: true,
  imports: [CommonModule, NgFor, SkeletonModule],
  templateUrl: './request-data.template.component.html',
  styleUrls: ['./request-data.template.component.scss']
})
export class SkeletorRequestDataTemplateComponent {
  @Input() items: number = 6;
  get rows() { return Array.from({ length: this.items }); }
}

